import { Stack, Box } from '@mui/material';
import { colors, IconButton, Tooltip } from '@sweep-io/sweep-design';
import { Search } from '@sweep-io/sweep-design/dist/icons';
import AgentSearch from '../AgentSearch';
import AgentChatsHistory from '../AgentChatsHistory';
import AgentActions from './AgentActions';
import { useSidebarCollapse } from './useSidebarCollapse';

const AgentSideMenu = () => {
  const { isCollapsed, setCollapse, toggleCollapse } = useSidebarCollapse();

  const handleSearchClick = () => {
    if (isCollapsed) {
      setCollapse(false);
      // Small delay to allow the sidebar to expand before focusing
      setTimeout(() => {
        const searchInput = document.querySelector(
          '[data-testid="search-input"], input[type="text"]',
        ) as HTMLInputElement;
        if (searchInput) {
          searchInput.focus();
        }
      }, 250);
    }
  };

  return (
    <Stack p={1.5} paddingRight={0}>
      <Stack
        p={isCollapsed ? 0.75 : 1}
        gap={isCollapsed ? 1.5 : 2}
        sx={{
          backgroundColor: colors.grey[100],
          borderRadius: '8px',
          flex: 1,
          width: isCollapsed ? '32px' : '292px',
          overflow: 'hidden',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          alignItems: isCollapsed ? 'center' : 'stretch',
          transformOrigin: 'left top',
        }}
      >
        <AgentActions isCollapsed={isCollapsed} onToggleCollapse={toggleCollapse} />

        {isCollapsed && (
          <Stack
            alignItems="center"
            justifyContent="center"
            sx={{
              opacity: isCollapsed ? 1 : 0,
              // Scale creates smooth zoom-in effect when appearing, avoids abrupt pop-in
              transform: isCollapsed ? 'scale(1)' : 'scale(0.8)',
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            }}
          >
            <Tooltip title="Search" placement="right">
              <IconButton variant="flat" size="small" onClick={handleSearchClick}>
                <Search />
              </IconButton>
            </Tooltip>
          </Stack>
        )}

        <Box
          sx={{
            opacity: isCollapsed ? 0 : 1,
            height: isCollapsed ? 0 : 'auto',
            overflow: 'hidden',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: isCollapsed ? '0s' : '0.1s',
            transform: isCollapsed ? 'translateY(-10px)' : 'translateY(0)',
          }}
        >
          {!isCollapsed && <AgentSearch />}
        </Box>

        <Box
          sx={{
            opacity: isCollapsed ? 0 : 1,
            height: isCollapsed ? 0 : 'auto',
            flex: isCollapsed ? '0 0 auto' : 1,
            overflow: 'hidden',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            transitionDelay: isCollapsed ? '0s' : '0.15s',
            // translateY creates "folding upward" effect - content slides up as it disappears
            transform: isCollapsed ? 'translateY(-20px)' : 'translateY(0)',
            display: 'flex',
          }}
        >
          {!isCollapsed && (
            <Stack
              sx={{
                overflow: 'auto',
                flex: 1,
              }}
            >
              <AgentChatsHistory />
            </Stack>
          )}
        </Box>
      </Stack>
    </Stack>
  );
};

export default AgentSideMenu;
